<template>
  <div class="fixed-whatsapp" @click="openWhatsApp">
    <VIcon icon="mdi-whatsapp" color="white"></VIcon>
  </div>
</template>
<script>
export default {
  name: 'FixedWhatsApp',
  methods: {
    openWhatsApp() {
      const url = 'https://api.whatsapp.com/send?phone=353831234000';
      window.open(url, '_blank', 'noreferrer');
    }
  }
};
</script>
